export const locale = {
  full_date_validation_message: 'Please enter date in MM/DD/YYYY format',
  short_date_validation_message: 'Please enter date in MM/DD/YY format',
  no_future_validation_message: 'Date should not be more than current day',
};
